import { createSlice } from "@reduxjs/toolkit";
import { fetchArchiveServicesProfileSchoolData,updateMergeDataToActualData } from "../thunks/archiveServicesThunk";

const archiveServicesSchoolProfileSlice = createSlice({
  name: "archiveProfileServices",
  initialState: {
    data: [{
            "regionType": "",
            "regionCode": "",
            "yearId": 11,
            "location": "India",
            "rural_urban": "Urban",
            "school_management": "School mgt.",
            "school_type": "School Type.",
            "itemGroupId": "1",
            "itemId": 1
    }],
    isLoading:true,
    isError:false,
    error:null
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchArchiveServicesProfileSchoolData.pending, (state) => {
        state.isLoading = true;
      })
      .addCase(fetchArchiveServicesProfileSchoolData.fulfilled, (state, action) => {
        state.isLoading = false;
        state.data = action.payload;
      })
      .addCase(fetchArchiveServicesProfileSchoolData.rejected, (state, action) => {
        state.isLoading = false;
        state.isError = true;
      })

      .addCase(updateMergeDataToActualData.fulfilled, (state, action) => {
        state.data.data = action.payload;
        state.isLoading = false;
      })
  },
});

export default archiveServicesSchoolProfileSlice.reducer;